import {createSlice, PayloadAction, createAsyncThunk} from '@reduxjs/toolkit';
import {UserService} from '@/shared/services/userService';
import type {RootState} from '../store';

type Panel = {
    name: string;
    code: string;
};

interface PanelState {
    panels: Panel[];
}

const initialState: PanelState = {
    panels: [],
};

export const fetchPanels = createAsyncThunk('panel/fetchPanels', async (_: void, api) => {
    const data = await UserService.getPanels();

    const panels: Panel[] = [];
    // We have decided to display the name of the panel with this data.
    // subbing at index 6 because that's where the space after "DTC - " is
    // Otherwise, display the regular panel name (e.g. Celiac)
    for (let i = 0; i < data.length; i++) {
        let name = data[i].name;
        if (name.includes('DTC - ')) {
            name = name.substring(6, name.length);
        }
        panels.push({
            code: data[i].code,
            name: name,
        });
    }

    api.dispatch(setPanels(panels));

    return panels;
});

export const panelSlice = createSlice({
    name: 'panels',
    initialState,
    reducers: {
        setPanels: (state, action: PayloadAction<Panel[]>) => {
            state.panels = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPanels.fulfilled, (state, action) => {
                if (action.payload) {
                    state.panels = action.payload;
                }
            })
            .addCase(fetchPanels.rejected, () => {
                // Keep existing panels on error
            });
    },
});

export const {setPanels} = panelSlice.actions;
export const selectPanel = (state: RootState) => state.panels;

export default panelSlice.reducer;
